import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaWifi } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import "./NbnPlans.css";

/* ⭐ ADD THIS IMPORT */
import NbnSearchBar from "../components/NbnSearchBar.tsx";

export default function NbnPlans(): JSX.Element {
  const location = useLocation();
  const state = location.state as { nbnType?: string };
  const [variant, setVariant] = useState<"fttb" | "fttp" | "hfc" | "fw" | "opticomm">("fttb");

  useEffect(() => {
    if (!state?.nbnType) return;

    const t = state.nbnType.toLowerCase();

    if (t === "fw" || t.includes("wireless")) setVariant("fw");
    else if (t === "opticomm") setVariant("opticomm");
    else if (t === "hfc") setVariant("hfc");
    else if (t === "fttp") setVariant("fttp");
    else setVariant("fttb");
  }, [state]);

  const nbnPlans = {
    fttb: [
      { name: "NBN 25/10", price: "$74/mo", data: "25/10 Mbps", note: "FTTB / FTTN / FTTC • Unlimited Data", popular: false },
      { name: "NBN 50/20", price: "$104/mo", data: "50/20 Mbps", note: "FTTB / FTTN / FTTC • Unlimited Data", popular: true },
      { name: "NBN 100/20", price: "$109/mo", data: "100/20 Mbps", note: "FTTB / FTTN / FTTC • Unlimited Data", popular: false },
      { name: "NBN 100/40", price: "$119/mo", data: "100/40 Mbps", note: "FTTB / FTTN / FTTC • Unlimited Data", popular: false },
    ],
    fttp: [
      { name: "NBN 25/10", price: "$74/mo", data: "25/10 Mbps", note: "FTTP • Unlimited Data • Static IP", popular: false },
      { name: "NBN 50/20", price: "$104/mo", data: "50/20 Mbps", note: "FTTP • Unlimited Data • Static IP", popular: true },
      { name: "NBN 250/100", price: "$114/mo", data: "250/100 Mbps", note: "FTTP • Unlimited Data • Static IP", popular: false },
      { name: "NBN 250/100 Priority", price: "$134/mo", data: "250/100 Mbps", note: "FTTP • Unlimited Data • Static IP • 4-hour priority fault rectification", popular: false },
      { name: "NBN 500/50", price: "$109/mo", data: "500/50 Mbps", note: "FTTP • Unlimited Data • Static IP", popular: true },
      { name: "NBN 500/200", price: "$139/mo", data: "500/200 Mbps", note: "FTTP • Unlimited Data • Static IP • 4-hour priority fault rectification", popular: false },
      { name: "NBN 750/50", price: "$119/mo", data: "750/50 Mbps", note: "FTTP • Unlimited Data • Static IP", popular: false },
      { name: "NBN 1000/100", price: "$134/mo", data: "1000/100 Mbps", note: "FTTP • Unlimited Data • Static IP", popular: false },
      { name: "NBN 1000/400", price: "$169/mo", data: "1000/400 Mbps", note: "FTTP • Unlimited Data • Static IP • 4-hour priority fault rectification", popular: false },
      { name: "NBN 2000/100", price: "$204/mo", data: "2000/100 Mbps", note: "FTTP • Unlimited Data • Static IP • May require NBN box upgrade", popular: false },
      { name: "NBN 2000/500", price: "$259/mo", data: "2000/500 Mbps", note: "FTTP • Unlimited Data • Static IP • 4-hour priority fault rectification • May require NBN box upgrade", popular: false },
    ],
    hfc: [
      { name: "NBN 25/10", price: "$74/mo", data: "25/10 Mbps", note: "HFC • Unlimited Data • Static IP", popular: false },
      { name: "NBN 50/20", price: "$104/mo", data: "50/20 Mbps", note: "HFC • Unlimited Data • Static IP", popular: true },
      { name: "NBN 250/100", price: "$134/mo", data: "250/100 Mbps", note: "HFC • Unlimited Data • Static IP • 4-hour priority fault rectification", popular: false },
      { name: "NBN 500/50", price: "$109/mo", data: "500/50 Mbps", note: "HFC • Unlimited Data • Static IP", popular: true },
      { name: "NBN 750/50", price: "$119/mo", data: "750/50 Mbps", note: "HFC • Unlimited Data • Static IP", popular: false },
      { name: "NBN 1000/100", price: "$134/mo", data: "1000/100 Mbps", note: "HFC • Unlimited Data • Static IP", popular: false },
      { name: "NBN 2000/100", price: "$204/mo", data: "2000/100 Mbps", note: "HFC • Unlimited Data • Static IP • May require NBN box upgrade", popular: false },
    ],
    fw: [
      { name: "Fixed Wireless 100/20", price: "$104/mo", data: "100/20 Mbps", note: "Fixed Wireless • Unlimited Data", popular: false },
      { name: "Fixed Wireless 250/20", price: "$109/mo", data: "250/20 Mbps", note: "Fixed Wireless • Unlimited Data", popular: true },
      { name: "Fixed Wireless 400/40", price: "$119/mo", data: "400/40 Mbps", note: "Fixed Wireless • Unlimited Data", popular: false },
    ],
    opticomm: [
      { name: "Opticomm 25/10", price: "$74/mo", data: "25/10 Mbps", note: "Opticomm • Unlimited Data", popular: false },
      { name: "Opticomm 50/20", price: "$104/mo", data: "50/20 Mbps", note: "Opticomm • Unlimited Data", popular: true },
      { name: "Opticomm 100/20", price: "$119/mo", data: "100/20 Mbps", note: "Opticomm • Unlimited Data", popular: false },
      { name: "Opticomm 100/40", price: "$129/mo", data: "100/40 Mbps", note: "Opticomm • Unlimited Data", popular: false },
      { name: "Opticomm 1000/100", price: "$169/mo", data: "1000/100 Mbps", note: "Opticomm • Unlimited Data", popular: false },
      { name: "Opticomm 500/200", price: "$204/mo", data: "500/200 Mbps", note: "Opticomm • Unlimited Data", popular: false },
      { name: "Opticomm 1000/400", price: "$259/mo", data: "1000/400 Mbps", note: "Opticomm • Unlimited Data", popular: false },
    ],
  };

  const getCISLink = () => {
    if (variant === "opticomm") return "/docs/Jortel Opticomm Critical Information Summary.pdf";
    if (variant === "fw") return "/docs/Jortel NBN FW Critical Information Summary.pdf";
    if (variant === "hfc") return "/docs/Jortel NBN HFC Critical Information Summary.pdf";
    if (variant === "fttp") return "/docs/Jortel NBN FTTP Critical Information Summary.pdf";
    return "/docs/Jortel NBN Critical Information Summary.pdf";
  };
  const currentCIS = getCISLink();

  const activePlans = nbnPlans[variant];

  return (
    <motion.main
      className="nbn-page"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >

      {/* Hero */}
      <motion.section className="nbn-hero-banner" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <h1>J-Data NBN</h1>
        <p>Fast, reliable internet — with Australian support.</p>
      </motion.section>

      {/* ⭐ ADDED SEARCH BAR */}
      <div className="nbn-search-on-nbn-page">
        <NbnSearchBar />
      </div>

      {/* Header */}
      <section className="nbn-header">
        <h2 className="nbn-title">
          <FaWifi className="nbn-icon" /> Choose Your NBN Type
        </h2>

        <div className="toggle-row">
          <button className={`toggle ${variant === "fttb" ? "active" : ""}`} onClick={() => setVariant("fttb")}>
            FTTB / FTTN / FTTC
          </button>
          <button className={`toggle ${variant === "fttp" ? "active" : ""}`} onClick={() => setVariant("fttp")}>
            FTTP
          </button>
          <button className={`toggle ${variant === "hfc" ? "active" : ""}`} onClick={() => setVariant("hfc")}>
            HFC
          </button>
          <button className={`toggle ${variant === "fw" ? "active" : ""}`} onClick={() => setVariant("fw")}>
            Fixed Wireless
          </button>
          <button className={`toggle ${variant === "opticomm" ? "active" : ""}`} onClick={() => setVariant("opticomm")}>
            Opticomm
          </button>
        </div>

        <div className="compare-summary">
          <span>✅ Unlimited Data</span>
          <span>{variant === "opticomm" ? "Static IP: $7.70/month extra" : "✅ Static IP Included"}</span>
          <span>✅ No CG-NAT</span>
          <span>✅ Month-to-Month</span>
        </div>
      </section>

      {/* Plans Grid */}
      <AnimatePresence mode="wait">
        <motion.div
          key={variant}
          className="nbn-grid"
          initial={{ opacity: 0, x: -15 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 15 }}
          transition={{ duration: 0.3 }}
        >
          {activePlans.map((p, i) => (
            <motion.div key={i} className={`nbn-card ${p.popular ? "popular" : ""}`} whileHover={{ scale: 1.04 }}>
              {p.popular && <div className="badge">⭐ Most Popular</div>}
              <h3>{p.name}</h3>
              <div className="price">{p.price}</div>
              <div className="speed">{p.data}</div>
              <div className="note">{p.note}</div>

              {currentCIS && (
                <div className="cis-inline">
                  <a href={currentCIS} target="_blank" rel="noopener noreferrer">
                    Critical Information Summary
                  </a>
                </div>
              )}
            </motion.div>
          ))}
        </motion.div>
      </AnimatePresence>

      <p className="fineprint center">
        {variant === "opticomm"
          ? "Prices include GST. A $99 start-up fee applies. Additional connection or non-standard installation fees may apply. Optional modem: $240 upfront or $10/month over 24 months; remaining modem costs are payable if you cancel early."
          : "A once-off $99 activation fee may apply for a new service. Optional modem available at extra cost."}
      </p>

      {/* WHY CHOOSE JORTEL */}
      <section className="nbn-advantages-section">
        <h2>Why Choose Jortel NBN</h2>

        <div className="nbn-advantages-grid">
          <div className="nbn-adv-card">
            <div className="icon">🖧</div>
            <h3>{variant === "opticomm" ? "Optional Static IP" : "Static IP as Standard"}</h3>
            <p>{variant === "opticomm"
              ? "Add a static IP for $7.70/month for hosting, VPNs and remote access."
              : "Perfect for small businesses and advanced users needing stable and consistent remote access."}</p>
          </div>

          <div className="nbn-adv-card">
            <div className="icon">🔒</div>
            <h3>No CG-NAT</h3>
            <p>Full IPv4 visibility for hosting, VPNs and security systems without restrictions.</p>
          </div>

          <div className="nbn-adv-card">
            <div className="icon">🤝</div>
            <h3>Australian Support</h3>
            <p>Sydney-based technical support team. No offshore handoffs — real help when you need it.</p>
          </div>
        </div>
      </section>

      {/* Advisor */}
      <section className="advisor-panel">
        <div className="advisor-content">
          <h2>Need Help Choosing the Right Plan?</h2>
          <p>Our Sydney-based team can help you find the best option for your home or business.</p>
          <a href="/contact" className="btn primary">Talk to an Expert</a>
        </div>
      </section>
    </motion.main>
  );
}

